import * as P from "../../polyfills";
export function initPolyfills() {
    Object.keys(P).forEach(function (x) {
        try {
            typeof P[x] === "function" && P[x]();
        }
        catch (e) {
            console.error("## ERR while polyfilling -> ", e);
        }
    });
}
//# sourceMappingURL=Polyfills.js.map